import { FETCH_SLIDES } from "../types";

export const slideReducer = (state = [], action) => {
  switch (action.type) {
    case FETCH_SLIDES:
      return action.payload;
    default:
      return state;
  }
};
